import {bufferTime, catchError, distinct, filter, map, mergeMap, startWith, tap, mapTo, first, toArray, endWith} from "rxjs/operators";
import {iif, of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {API_GET_BID, API_GET_BID_DONE, API_GET_BIDS_DONE, getBidDone} from "../actions/bids";
import * as R from 'ramda';
import {getBids$, getBidsMulti$} from "../services/bids";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {setView, setViewCache} from "../actions/view";

const SVCLF = setViewCache({loading: false});

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_BID),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setViewCache({loading: true})),
  catchErrorsandResume(20003)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_BID_DONE, API_GET_BIDS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setViewCache({loading: false})),
  catchErrorsandResume(20004)
);

const getSingleEpicMulti = action$ => action$.pipe(
  ofType(API_GET_BID),
  distinct(action => action.payload.id, requestDedupInterval$),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  mergeMap(actions => iif(() => actions.length > 1,
    getBidsMulti$({ ids: actions.map(action => action.payload.id) }).pipe(
      map(({ response }) => setView(response.results)),
      startWith(setViewCache({loading: true})),
      catchError(error => of(SVCLF, networkError({...error, number: '10074-'+error.status})))
    ),
    getBids$({ id: actions[0].payload.id }).pipe(
      map(({ response }) => getBidDone(response)),
      catchError(error => {
        if (error.status === 404) return of(getBidDone({
          resource: { id: actions[0].payload.id },
          permissions: {},
          status: error.status
        }));
        return of(SVCLF, networkError({...error, number: '10075-'+error.status}));
      })
    ),
  )),
  catchErrorsandResume(20006)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_BID),
  distinct(action => action.payload.id, requestDedupInterval$),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length === 1),
  map(actions => actions[0]),
  mergeMap(action => getBids$({ id: action.payload.id }).pipe(
    map(({ response }) => getBidDone(response)),
    catchError(error => of(networkError({...error, number: '10076-'+error.status})))
  )),
  catchErrorsandResume(20005)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_BID_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(bids => bids[0].callback && bids[0].callback(bids[0].response.resource.id)),
  map(results => results.map(bid => bid.response)),
  map(results => setView(results)),
  catchErrorsandResume(20008)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_BIDS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => setView(results)),
  catchErrorsandResume(20007)
);

export const bidsEpic = combineEpics(
  beginLoading,
  endLoading,
  getSingleEpicMulti,
  processSingleEpic,
  processMultipleEpic,
);



// WEBPACK FOOTER //
// ./src/network/bids.js